import { propOr } from "ramda";
import Info from "./info";
import Insurance from "./insurance";
import Physician from "./physician";
import MultifactorOptions from "./multifactor-options";
import ChangePasswordModal from "./change-password-modal";
import EditProfileScreen from "components/edit-profile";

export const renderTabContent = (selectedTab, editMode, formProps, profile) => {
  if (editMode && selectedTab !== 2) {
    return (
      <EditProfileScreen formProps={formProps} selectedTab={selectedTab} />
    );
  }

  const tabContents = {
    0: (
      <div role="tabpanel" id="profile-tabpanel-0" aria-labelledby="profile-tab-0">
        <Info patientInfo={propOr({}, "patient_information", profile)} />
      </div>
    ),
    1: (
      <div
        role="tabpanel"
        id="profile-tabpanel-1"
        aria-labelledby="profile-tab-1"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          padding: 0
        }}
      >
        <Insurance insurances={propOr([], "insurances", profile)} />
        <Physician
          physicians={propOr([], "physicians", profile)}
        />
      </div>
    ),
    2: (
      <div role="tabpanel" id="profile-tabpanel-2" aria-labelledby="profile-tab-2">
        <div className="security-tab-panel">
          <MultifactorOptions
            patientInfo={propOr({}, "patient_information", profile)}
          />
          <ChangePasswordModal />
        </div>
      </div>
    )
  };

  return tabContents[selectedTab] || null;
};
